import { FormsModule } from '@angular/forms'
import { MeasureMapComponent } from './measure-map.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { RadioModule } from '@components/radio/radio.module'
import { MapCoordinatesFinderModule } from '@components/map-coordinates-finder/map-coordinates-finder.module'

@NgModule({
  declarations: [MeasureMapComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule,
    ContentEditableModule,
    RadioModule,
    MapCoordinatesFinderModule,
  ],
  exports: [MeasureMapComponent],
})
export class MeasureMapModule {}
